import React, { useMemo } from 'react';
import { useSubscriberDomainParams } from 'global/hooks/useSubscriberDomainParams';
import HealthQuestionnairePageStore, {
  HealthQuestionnairePageStoreContext,
} from 'store/pages/subscriber/imq/health-questionnaire/pageStore';
import PageContent from 'components/subscriber/imq/health-questionnaire';

const HealthQuestionnairePage: React.FC = () => {
  const { groupId, subscriberId, entityId } = useSubscriberDomainParams();

  const pageStore = useMemo(
    () => new HealthQuestionnairePageStore({ groupId, subscriberId, entityId }),
    [groupId, subscriberId, entityId],
  );

  return (
    <HealthQuestionnairePageStoreContext.Provider value={pageStore}>
      <PageContent />
    </HealthQuestionnairePageStoreContext.Provider>
  );
};

export default HealthQuestionnairePage;
